import { AttributeTypeDef } from '../generated/types'
import { RegionAttr } from '../attributes'

export function isRegionAttr(attr?: AttributeTypeDef): attr is RegionAttr {
    return attr?.value.valueType === 'region'
}
